
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateRoletypeDtoFormGroup() {
return new FormGroup({
    label: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(2000)]),
    defaultForNewEmployees: new FormControl<boolean | undefined>(false),
})
;
}
      